import axios from 'axios';
import {config} from '../../services/configService';

export default {
    /**
     * Search flights
     *
     * @param {Object} data
     *
     * @return {Array}
     */
    async search(data) {
        return await axios.post(config.trip.route.search, data).then(response => response.data);
    },
    /**
     * Select flight
     *
     * @param {string} searchMode
     * @param {Object} flight|null
     *
     * @return {void}
     */
    selectFlight(searchMode, flight) {
        axios.post(config.trip.route.select, {searchMode, flight}).then(response => response.data).catch(exception => {
            console.log(exception.response.data);
        });
    },
    /**
     * Purchase flight
     *
     * @param {Object} card
     * @param {Array} travellers
     * @param {Object} flight
     *
     * @return {Object|false}
     */
    async purchaseFlight(card, travellers, flight) {
        try {
            return await axios.post(config.trip.route.purchase, {
                card,
                travellers,
                flight,
                userId: config.userId
            }).then(response => response.data);
        } catch {
            return false;
        }
    },
    /**
     * Get airlines details
     *
     * @param {Array} codes - List of airlines codes
     *
     * @return {Array}
     */
    async getAirlinesDetails(codes) {
        try {
            return await axios.post(config.locations.route.airlines, {codes}).then(response => {
                if (response.data.error) {
                    throw response.data.error;
                }
                return response.data.response;
            });
        } catch {
            return [];
        }
    },
    /**
     * Get airports details
     *
     * @param {Array} codes - List of airports codes
     *
     * @return {Array}
     */
    async getAirportsDetails(codes) {
        try {
            return await axios.post(config.locations.route.airports, {codes}).then(response => {
                if (response.data.error) {
                    throw response.data.error;
                }
                return response.data.response;
            });
        } catch {
            return [];
        }
    },
    /**
     * Get locations details by query
     *
     * @param {string} query
     *
     * @return {Array}
     */
    async getLocations(query) {
        try {
            return await axios.post(config.locations.route.autocomplete, {query}).then(response => {
                if (response.data.error) {
                    throw response.data.error;
                }
                const locations = [];
                const filteredLocations = [];
                const addLocation = (location, type) => {
                    location.type = type;
                    location.country = location.country_name;
                    locations.push(location);
                };
                response.data.response.airports.forEach(airport => addLocation(airport, 'airport'));
                response.data.response.airports_by_cities.forEach(airport => addLocation(airport, 'airport'));
                response.data.response.airports_by_countries.forEach(airport => addLocation(airport, 'airport'));
                response.data.response.cities.forEach(city => addLocation(city, 'city'));
                response.data.response.cities_by_countries.forEach(city => addLocation(city, 'city'));
                response.data.response.cities_by_airports.forEach(city => addLocation(city, 'city'));
                locations.forEach(location => {
                    if (!filteredLocations.find(filteredLocation => filteredLocation.code === location.code)) {
                        filteredLocations.push(location);
                    }
                });
                return filteredLocations.sort((firstLocation, secondLocation) => firstLocation.name.localeCompare(secondLocation.name));
            });
        } catch {
            return [];
        }
    }
};